import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
const useOverviewFilters = providerId => {
  const {
    t
  } = useTranslation();
  const values = useMemo(() => {
    const base = [{
      label: t('DASHBOARD_ANALYTICS.last30Days', 'Ultimi 30 giorni'),
      value: 'last30'
    }, {
      label: t('DASHBOARD_ANALYTICS.last90Days', 'Ultimi 90 giorni'),
      value: 'last90'
    }];
    const extended = +providerId === 918 ? [{
      label: t('DASHBOARD_ANALYTICS.last120Days', 'Ultimi 120 giorni'),
      value: 'last120'
    }, {
      label: t('DASHBOARD_ANALYTICS.last150Days', 'Ultimi 150 giorni'),
      value: 'last150'
    }] : [];
    const rest = [{
      label: t('DASHBOARD_ANALYTICS.currentMonth', 'Mese corrente'),
      value: 'currentMonth'
    }, {
      label: t('DASHBOARD_ANALYTICS.lastMonth'),
      value: 'lastMonth'
    }];
    return [...base, ...extended, ...rest];
  }, [providerId, t]);
  return values;
};
export { useOverviewFilters };